import { country as esp } from './esp'
import { country as cri } from './cri'

import { json as api } from './api'

export const countryRoutes = { esp, cri }
export const apiRoutes = api
